import ManageStocksMainPage from "../../components/manageStocksV2/ManageStocksMainPage";

const Index = () => {
  return (
    <div>
      <ManageStocksMainPage />
    </div>
  );
};

export default Index;
